// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1Z11f","label":"Radio_label__1bgtx","checkMark":"Radio_checkMark__1Zk5X","disabled":"Radio_disabled__3C913"};